import React from 'react';
import { Flex } from '@leagueplatform/genesis-commons';

// eslint-disable-next-line react/jsx-props-no-spreading
export const FieldGrid = (props) => <Flex flexWrap="wrap" {...props} />;
